import React from 'react';
import  {Navbar} from "./components/NavBar";
import { AuthProvider } from './context/authContext'; 
import {MainRoutes} from "./components/MainRoutes";


function App() {
  return (
      <div>
            <AuthProvider>
        <Navbar postID={''} />
        <MainRoutes />
    </AuthProvider>
       
      </div>
   
  );
}

export default App;
